import { render, staticRenderFns } from "./PrintPassButton.vue?vue&type=template&id=f3966ea4&"
import script from "./PrintPassButton.vue?vue&type=script&lang=js&"
export * from "./PrintPassButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports